import { Translation } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';

import { getTimeFormatPropsFromTimeDiff, useCountdown } from '@swf/poker';

import { usePokerSundayMillionWidget } from '../../../model';

const EventCountdown: React.FC = () => {
  const { widgetSelect } = usePokerSundayMillionWidget();
  const date = useSelector(widgetSelect.getTimerDate);
  const countdown = useCountdown(date);
  const { translation, values } = getTimeFormatPropsFromTimeDiff(countdown);
  return <Translation {...translation} values={values} />;
};

export default EventCountdown;
